module.exports = __webpack_public_path__ + "img/icon1.6a9a843b.png";